import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../config'; // Adjust path if needed

const Layout = ({ children, isAdmin }) => {
  const navigate = useNavigate();
  const currentPath = window.location.pathname;
  const [settingsVisible, setSettingsVisible] = useState(true);
  const [affiliateVisible, setAffiliateVisible] = useState(false);

  // Fetch user data to determine settings visibility
  useEffect(() => {
    const fetchUserData = async () => {
      // Only fetch for regular users, not admins
      if (isAdmin) return;
      
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          navigate('/login');
          return;
        }

        const response = await fetch(`${config.apiUrl}/user`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.ok) {
          const userData = await response.json();
          setSettingsVisible(userData.settings_visible);
          setAffiliateVisible(!!userData.affiliate_tab_visible);
        }
      } catch (err) {
        console.error('Error fetching user data:', err);
        // Default to showing settings if there's an error
      }
    };

    fetchUserData();
  }, [isAdmin, navigate]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('isAdmin');
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <nav className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex">
              <div className="flex-shrink-0 flex items-center">
                <span className="text-xl font-bold">MT5 Manager</span>
              </div>
              <div className="ml-6 flex space-x-8">
                {isAdmin ? (
                  <>
                    <button
                      onClick={() => navigate('/admin/dashboard')}
                      className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium ${
                        currentPath === '/admin/dashboard'
                          ? 'border-indigo-500 text-gray-900'
                          : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                      }`}
                    >
                      Admin Dashboard
                    </button>
                    
                    <button
                      onClick={() => navigate('/admin/affiliate')}
                      className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium ${
                        currentPath === '/admin/affiliate'
                          ? 'border-indigo-500 text-gray-900'
                          : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                      }`}
                    >
                      Affiliate
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      onClick={() => navigate('/')}
                      className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium ${
                        currentPath === '/'
                          ? 'border-indigo-500 text-gray-900'
                          : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                      }`}
                    >
                      Dashboard
                    </button>
                    {/* Only show Settings button if settings are visible */}
                    {settingsVisible && (
                      <button
                        onClick={() => navigate('/settings')}
                        className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium ${
                          currentPath === '/settings'
                            ? 'border-indigo-500 text-gray-900'
                            : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                        }`}
                      >
                        Settings
                      </button>
                    )}
                    {/* Affiliate tab for users (only if enabled by admin) */}
                    {affiliateVisible && (
                      <button
                        onClick={() => navigate('/affiliate')}
                        className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium ${
                          currentPath === '/affiliate'
                            ? 'border-indigo-500 text-gray-900'
                            : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                        }`}
                      >
                        Affiliate
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="ml-6 flex items-center">
              <button
                onClick={handleLogout}
                className="bg-indigo-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-indigo-700"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </nav>

      <main className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow p-6">
          {children}
        </div>
      </main>

      <footer className="bg-white shadow mt-8">
        <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8">
          <p className="text-center text-sm text-gray-500">
            © 2024 MT5 Manager. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
